import { GammaBadge, Icon, SecondaryPill } from '@joor/design-system'
import styled from 'styled-components'

import { IDropdownMenuText } from 'features/Navbar/NavbarRevamp/navbarRevamp.types'

const MenuTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: var(--size-font-small);
  font-weight: var(--font-weight-medium);
  font-family: var(--font-family-alpha);
  letter-spacing: 0.6px;
  line-height: 16px;
  padding: 4px 9px;
  width: 100%;

  &:hover {
    border: 1px solid var(--color-primary-400);
    border-radius: 4px;
    padding: 3px 8px;
    cursor: pointer;
  }
`

const MenuTextMessage = styled.span`
  color: var(--color-secondary-800);
`

const MenuPill = styled.span`
  margin-left: 8px;
`

const DropdownMenuText = ({
  className,
  isNew = false,
  newPosition = 'end',
  message,
  onClick,
  testId,
  id,
  count,
  badge,
  iconName,
}: IDropdownMenuText) => (
  <MenuTextContainer
    className={className}
    onClick={(event) => onClick && onClick(event)}
    data-testid={testId}
    id={id}
  >
    {isNew && newPosition === 'beginning' && (
      <MenuPill>
        <SecondaryPill>New!</SecondaryPill>
      </MenuPill>
    )}
    <MenuTextMessage>{message}</MenuTextMessage>
    {badge}
    {iconName && (
      <Icon
        plain
        iconSize={'small'}
        variant="ACTIVE"
        iconName={iconName}
        data-testid="dropdown-menu-text-icon"
      />
    )}
    {isNew && newPosition === 'end' && (
      <MenuPill>
        <SecondaryPill>New!</SecondaryPill>
      </MenuPill>
    )}
    {!!count && (
      <span style={{ marginLeft: '10px' }}>
        <GammaBadge value={count} />
      </span>
    )}
  </MenuTextContainer>
)

export default DropdownMenuText
